import React from 'react';
import { Button } from "react-bootstrap";
import { Form } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import LoadingButtonWithForm from '../../../components/LoadingButtonWithForm';
import { Link, useParams } from 'react-router-dom';
import { convertToFormData, sweetAlert } from '../../../utils';
import { useSaveApplicationMutation } from '../../../redux/services/ApplicationService';
import { responseError } from '../../../helpers/responseHandler';
import { FILE_URL } from '../../../redux/services/apiConstant';

const StepOne = ({ activeStep, setActiveStep, params, isEdit, setIsEdit }) => {
    let {
        control,
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        formState: { errors },
    } = useForm()
    const [editRequest, { isLoading: editLoading }] = useSaveApplicationMutation()


    const onSubmit = async (data) => {
        const newForm = convertToFormData({ step_no: '7', ...data })
        setIsEdit(prev => { return { ...prev, ...newForm } })
        await editRequest({ params, newForm }).unwrap()
            .then((res) => {
                setActiveStep(6)
                if (res?.status) {
                    sweetAlert(res?.message, 'success')
                }
                // if (res?.errors) {
                //     Object.entries(res?.errors)?.forEach(([key, value]) => {
                //         sweetAlert(value[0], 'error')
                //     })
                // }
            })
            .catch((err) => {
                responseError(err)
            })
    }
    return (
        <>
            <div className="row justify-content-center">
                <div className="col-xl-10">
                    <div className="card custom-card">
                        <div className="card-body">
                            <h5 className="text-center">Motor Vehicle Record (MVR)</h5>

                            <div className="row">
                                <Form onSubmit={handleSubmit(onSubmit)} className="col-md-12" id='application-status'>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label htmlFor='authorization_mvr_check'>Authorization for MVR Check:</Form.Label>
                                                <Controller
                                                    name='authorization_mvr_check'
                                                    control={control}
                                                    defaultValue={isEdit?.authorization_mvr_check == 'true' ? true : false}
                                                    rules={{ required: true }}
                                                    render={({ field }) => (
                                                        <Form.Check
                                                            type="checkbox"
                                                            defaultChecked={field.value}
                                                            id="authorization_mvr_check"
                                                            label="I authorize the release of my Motor Vehicle Record (MVR) to the Company"
                                                            {...field}
                                                            isInvalid={errors.authorization_mvr_check}
                                                        />
                                                    )}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Driver’s License Number:</Form.Label>
                                                <Controller
                                                    name='mvr_dln'
                                                    control={control}
                                                    defaultValue={isEdit?.mvr_dln || ''}
                                                    rules={{ required: true }}
                                                    render={({ field }) => (
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Enter Driver’s License Number"
                                                            {...field}
                                                            isInvalid={errors.mvr_dln}
                                                        />
                                                    )}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>State of Issue:</Form.Label>
                                                <Controller
                                                    name='mvr_state_issue'
                                                    control={control}
                                                    defaultValue={isEdit?.mvr_state_issue || ''}
                                                    rules={{ required: true }}
                                                    render={({ field }) => (
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Enter State of Issue"
                                                            {...field}
                                                            isInvalid={errors.mvr_state_issue}
                                                        />
                                                    )}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>MVR Expiration Date:</Form.Label>
                                                <Controller
                                                    name='mvr_expiration_date'
                                                    control={control}
                                                    defaultValue={isEdit?.mvr_expiration_date || ''}
                                                    rules={{ required: true }}
                                                    render={({ field }) => (
                                                        <Form.Control
                                                            type="date"
                                                            placeholder="Enter MVR Expiration Date"
                                                            {...field}
                                                            isInvalid={errors.mvr_expiration_date}
                                                        />
                                                    )}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Upload MVR Report:</Form.Label>
                                                <Controller
                                                    name='mvr_report'
                                                    control={control}
                                                    defaultValue={''}
                                                    rules={{
                                                        required: isEdit?.mvr_report ? false : true,
                                                        validate: {
                                                            fileSize: (file) => {
                                                                if (!file) return true; // allow empty if not required
                                                                return file.size <= 5 * 1024 * 1024 || 'File size must be less than 5MB';
                                                            },
                                                            fileType: (file) => {
                                                                if (!file) return true; // skip if not required
                                                                const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
                                                                return allowedTypes.includes(file.type) || 'Only JPEG, PNG, or PDF files are allowed';
                                                            },
                                                        },
                                                    }}
                                                    render={({ field }) => (
                                                        <>
                                                            <Form.Control
                                                                type="file"
                                                                onChange={(e) => field.onChange(e.target.files[0])}
                                                                isInvalid={errors.mvr_report}
                                                            />

                                                            {errors.mvr_report && (
                                                                <Form.Control.Feedback type="invalid">
                                                                    {errors.mvr_report.message}
                                                                </Form.Control.Feedback>
                                                            )}
                                                        </>
                                                    )}
                                                />
                                                {isEdit?.mvr_report_url && (
                                                    <Link to={isEdit?.mvr_report_url || ''} target='_blank'>
                                                        <span className='d-inline-block text-primary my-1'>View Uploaded File</span>
                                                    </Link>
                                                )}
                                            </Form.Group>
                                        </div>
                                    </div>
                                </Form>
                                <div className="col-lg-3 d-flex mb-3">
                                    <Button
                                        variant="secondary"
                                        className="mt-auto w-100"
                                        onClick={() => setActiveStep(4)}
                                    >
                                        Previous
                                    </Button>
                                </div>
                                {/* <div className="col-lg-3 d-flex mb-3">
                                    <Button
                                        variant="secondary"
                                        className="mt-auto w-100"
                                        onClick={() => setActiveStep(6)}
                                    >
                                        Next
                                    </Button>
                                </div> */}
                                <div className="col-lg-3 d-flex mb-3">
                                    <LoadingButtonWithForm
                                        isLoading={editLoading}
                                        name="Next & Save"
                                        form="application-status"
                                        className="text-white mt-auto w-100"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StepOne;